module.exports = __webpack_public_path__ + "1714aa34f2c9c2dd6e343a783c1b1c9e.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/brokerage/verify.png
// module id = 684
// module chunks = 0